
    import Component from 'vue-class-component';
    import { BaseInspector } from 'src/components/Chatbot/Inspector//Base-inspector/base-inspector';

    @Component({})
    export default class LabelInspector extends BaseInspector {

        public label: string = '';

        public props = {
            label: ['attrs', 'label', 'text']
        }

        protected assignFormFields(): void {
            const { cell, props } = this;
            this.label = cell.prop(props.label);
        }
    }
